import React from "react";
import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import { useStickyTab } from "../../../utils/uiPrefs";
import AlertsFeed from "./AlertsFeed";
import AlertsConfig from "./AlertsConfig";

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index} style={{ width: "100%" }}>
    {value === index && <Box sx={{ pt: { xs: 1, md: 2 } }}>{children}</Box>}
  </div>
);

/**
 * Alerts: what has fired, and how alerting is set up.
 *
 * The two tabs answer different questions — "what needs attention right now"
 * versus "who hears about it" — so they mount independently and each fetches
 * its own data.
 */
const AlertsPage: React.FC = () => {
  const [tab, setTab] = useStickyTab("alerts.v1", 2);

  return (
    <Card sx={{ m: { xs: 1, md: 2 } }}>
      <CardContent sx={{ p: { xs: 1, md: 2 } }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, px: { xs: 1, md: 0 } }}>
          Alerts
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            aria-label="Alerts tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="Alerts" sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }} />
            <Tab
              label="Configuration"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
            />
          </Tabs>
        </Box>

        <TabPanel value={tab} index={0}>
          <AlertsFeed />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <AlertsConfig />
        </TabPanel>
      </CardContent>
    </Card>
  );
};

export default AlertsPage;
